import { useState } from "react";
import { useSelector } from "react-redux";
import { fetchCitationFields } from "features/Bookmarks/services/citation.service";

const useCitationFields = () => {
  const { user } = useSelector((state) => state.auth);
  const { itemTypes, summaryInfoData } = useSelector((state) => state.data);

  const fetchFields = async (
    currentItemType,
    baseFields,
    setLoading,
    setFields,
    setRequiredFields,
    selectedStyle = "apa"
  ) => {
    if (!currentItemType) return;

    setLoading(true);
    let dynamicFields = {},
      baseFieldMappings = {},
      requiredFields = [],
      softRequiredFields = [],
      currentItem = "";

    if (currentItemType.length > 0)
      currentItem = itemTypes.filter(
        (item) => item.key.toLowerCase() === currentItemType.toLowerCase()
      )[0];
    try {
      const isDatabaseSearch = Boolean(
        summaryInfoData?.isDatabaseSearch ||
        (summaryInfoData?.dbId && summaryInfoData?.an)
      );
      const data = await fetchCitationFields(user, currentItem, selectedStyle, isDatabaseSearch);

      if (!data || !data[0]) throw new Error("No field data received");

      const itemData = data[0];

      (itemData.dynamicFields || []).forEach((item) => {
        dynamicFields[item.fieldName_chr] = item.displayFieldName_chr;
        if (item.baseFieldName_chr) {
          baseFieldMappings[item.fieldName_chr] = item.baseFieldName_chr;
        }
        if (item.isSoftRequired_ysn) {
          softRequiredFields.push(item.fieldName_chr);
        } else if (item.isRequired_ysn) {
          requiredFields.push(item.fieldName_chr);
        }
      });

      // Process Creators based on properties returned by the service
      const authors = (itemData.creators || []).reduce((acc, item) => {
        if (item.isDefault_ysn) {
          if (item.creatorName_chr === "author") {
            acc["creators"] = "Author";
          } else {
            acc[item.creatorName_chr] = item.displayName_chr;
          }
        }

        const fieldKey = item.creatorName_chr === "author" ? "creators" : item.creatorName_chr;

        if (item.isSoftRequired_ysn) {
          softRequiredFields.push(fieldKey);
        } else if (item.isRequired_ysn) {
          requiredFields.push(fieldKey);
        }
        return acc;
      }, {});

      setFields({ ...authors, ...dynamicFields });
      setRequiredFields(requiredFields);

      return {
        fields: { ...authors, ...dynamicFields },
        baseFields: baseFieldMappings,
        softRequiredFields: softRequiredFields
      };
    } catch (e) {
      console.error(e);
    }

    return {
      fields: {},
      baseFields: {},
      softRequiredFields: []
    };
  };

  return { fetchFields };
};

export default useCitationFields;
